<template>
  <div>
    <parameter-information-description :model="detail"></parameter-information-description>
  </div>
</template>

<script>
import ParameterInformationDescription
  from '@/views/equipmentLedger/modules/dataTabsModel/parameterInformationDescription.vue'

export default {
  components: { ParameterInformationDescription },
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) {
          this.initData(model)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      detail: []
    }
  },
  methods: {
    initData (model) {
      this.detail = []
      if (model.fieldValueList) {
        for (const item of model.fieldValueList) {
          const data = {
            fieldId: item.fieldId,
            vaules: item.vaules,
            name: item.name
          }
          this.detail.push(data)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
